import type { IconSvgObject } from './types';

const GalleryHorizontalIcon: IconSvgObject = [
  ["path", { d: "M2 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 3H12C10.8954 3 10 3.89543 10 5V19C10 20.1046 10.8954 21 12 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 4V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GalleryHorizontalIcon;
